import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

//*********//
//* Buefy *//
//*********//

import Buefy from "buefy";

Vue.use(Buefy);

//**************//
//* Prismic.io *//
//**************//

// @ts-ignore
import PrismicVue from "prismic-vue";
import linkResolver from "./prismic/link-resolver";

const accessToken =
  "MC5YcmI2U1JFQUFDTUF2UVc3.77-9a1wvHu-_vQzvv71XfO-_ve-_ve-_vTAaL--_ve-_vSDvv73vv73vv73vv73vv73vv70E77-977-977-977-9Xu-_vQ";
Vue.use(PrismicVue, {
  endpoint: "https://fan-fair.cdn.prismic.io/api/v2",
  linkResolver,
  apiOptions: { accessToken }
});

//****************//
//* Font Awesome *//
//****************//
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
